import React from "react";
import ErrorImage from "../../assets/warning.svg";
import SuccessImage from "../../assets/success.png";
import "./AffiliateCodeModal.scss";

const AffiliateCodeModal = ({
  code,
  error,
  isOpened,
  isSaving,
  isSuccess,
  onBack,
  onChange,
  onPricingPlanClick,
  onSubmit,
  onSuccessClose
}) => {
  if (!isOpened) return null;

  const isInactiveCodeError = error?.includes("select a new plan");

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit();
  };
  return (
    <div className="AffiliateCodeModal" onClick={isSaving ? undefined : onBack}>
      <div
        className="AffiliateCodeModal__content"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="AffiliateCodeModal__heading">
          <div className="AffiliateCodeModal__heading__imgWrapper">
            <img
              src={isSuccess ? SuccessImage : ErrorImage}
              alt={isSuccess ? "Success" : "Error"}
              className="AffiliateCodeModal__heading__imgWrapper__img"
            />
          </div>

          {isSuccess ? (
            <>
              <p className="AffiliateCodeModal__heading__title">Success!</p>
              <p className="AffiliateCodeModal__heading__text">
                Your affiliate code has been applied successfully.
              </p>
            </>
          ) : (
            <>
              <p className="AffiliateCodeModal__heading__title">
                You don't have an active plan, please enter your affiliate code
              </p>

              <form
                className="AffiliateCodeModal__form"
                onSubmit={handleSubmit}
              >
                <input
                  className="EditProfileCont__content__items__inp w-100"
                  disabled={isSaving}
                  onChange={(event) => onChange(event.target.value)}
                  placeholder="Affiliate code"
                  type="text"
                  value={code}
                />

                {error ? (
                  isInactiveCodeError ? (
                    <div
                      className="AffiliateCodeModal__form__errorWrap"
                      role="alert"
                    >
                      <span className="AffiliateCodeModal__form__errorText">
                        No active code exists, please reach out to your
                        organization’s administrator or Career Scoops Support or{" "}
                      </span>
                      <button
                        className="AffiliateCodeModal__form__link"
                        onClick={onPricingPlanClick}
                        type="button"
                      >
                        Select a new plan
                      </button>
                    </div>
                  ) : (
                    <p
                      className="AffiliateCodeModal__form__errorText"
                      role="alert"
                    >
                      {error}
                    </p>
                  )
                ) : null}
              </form>
            </>
          )}
        </div>

        {isSuccess ? (
          <button
            className="AffiliateCodeModal__btn"
            onClick={onSuccessClose}
            type="button"
          >
            <p className="AffiliateCodeModal__btn__text">OK</p>
          </button>
        ) : (
          <div className="AffiliateCodeModal__btns">
            <button
              className="AffiliateCodeModal__btns__back"
              disabled={isSaving}
              onClick={onBack}
              type="button"
            >
              <p className="AffiliateCodeModal__btns__back__text">Back</p>
            </button>
            <button
              className="AffiliateCodeModal__btns__ok"
              disabled={isSaving}
              onClick={onSubmit}
              type="button"
            >
              <p className="AffiliateCodeModal__btns__ok__text">
                {isSaving ? "Loading..." : "OK"}
              </p>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AffiliateCodeModal;
